var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from "react";
import { Pane } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { useStableOkapiKy } from "./useStableOkapiKy";
import { useModal } from "../utils/useModal";
import { useDetailParam } from "../utils/detailParam";
import { usePermissions } from "./usePermissions";
import { useDeclareLastUsedNumberAction } from "./useDeclareLastUsedNumberAction";
import { useResetDeclarationAction } from "./useResetDeclarationAction";
import { fetchPublisherPrefixById } from "../api/publisherPrefixService";
import PublisherPrefixDetail from "../routes/publisher-prefix/PublisherPrefixDetail";
import { buildPublisherPrefixActionMenu, } from "../routes/publisher-prefix/publisherPrefixActionMenu";
export var usePublisherPrefixActions = function () {
    var ky = useStableOkapiKy();
    var history = useHistory();
    var formatMessage = useIntl().formatMessage;
    var canEditPublisherPrefix = usePermissions().canEditPublisherPrefix;
    var _a = useModal(), isOpen = _a.isOpen, message = _a.message, action = _a.action, closeModal = _a.closeModal;
    var _b = useDetailParam(), detailId = _b.detailId, updateDetailParam = _b.updateDetailParam;
    var _c = useState(null), selectedItem = _c[0], setSelectedItem = _c[1];
    var _d = useDeclareLastUsedNumberAction(selectedItem), canShowDeclareAction = _d.canShowDeclareAction, declareAction = _d.declareAction;
    var _e = useResetDeclarationAction(selectedItem, setSelectedItem), canShowResetAction = _e.canShowResetAction, renderResetAction = _e.renderResetAction, resetModals = _e.resetModals;
    var extraActions = __spreadArray(__spreadArray([], (canShowDeclareAction ? [function () { return declareAction; }] : []), true), (canShowResetAction ? [renderResetAction] : []), true);
    useEffect(function () {
        var run = function () { return __awaiter(void 0, void 0, void 0, function () {
            var item, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(detailId && (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) !== detailId)) return [3 /*break*/, 5];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetchPublisherPrefixById(ky, detailId)];
                    case 2:
                        item = _b.sent();
                        setSelectedItem(item !== null && item !== void 0 ? item : null);
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        setSelectedItem(null);
                        updateDetailParam(null);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        if (!detailId) {
                            setSelectedItem(null);
                        }
                        _b.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        run();
    }, [ky, selectedItem, detailId, updateDetailParam]);
    var handleRowClick = function (item) {
        updateDetailParam(item.id);
        setSelectedItem(item);
    };
    var handleCloseDetail = function () {
        setSelectedItem(null);
        updateDetailParam(null);
    };
    var renderDetailPane = function () {
        if (!selectedItem)
            return null;
        return (React.createElement(Pane, { id: "detailPane", defaultWidth: "35%", paneTitle: formatMessage({
                id: "ui-br-agency.publisher-prefix.detail.pane.title",
            }), onClose: handleCloseDetail, dismissible: true, actionMenu: buildPublisherPrefixActionMenu(selectedItem, canEditPublisherPrefix, function () {
                return history.push("/bragency/publisher-prefixes/edit/".concat(selectedItem.id));
            }, extraActions) },
            React.createElement(PublisherPrefixDetail, { publisherPrefix: selectedItem }),
            resetModals));
    };
    return {
        selectedItem: selectedItem,
        isModalOpen: isOpen,
        modalMessage: message,
        modalAction: action,
        closeModal: closeModal,
        handleRowClick: handleRowClick,
        handleCloseDetail: handleCloseDetail,
        renderDetailPane: renderDetailPane,
    };
};
